import React from "react";
import {
    Box,
    Paper,
    Stack,
    Typography,
} from "@mui/material";

import {
    TipsAndUpdates as TipsAndUpdatesIcon,
} from "@mui/icons-material";

// Reusable "how to use this tab" empty state — shown before a
// teacher has made a selection (a student, or a set of students).
// Shared by Create Student Assessment and Batch Entry so both
// tabs greet the teacher with the same look, just different
// copy and an optional highlighted usage tip.

const AssessmentTabEmptyState = ({
    icon: Icon,
    title,
    description,
    tip,
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: {
                    xs: 4,
                    sm: 6,
                },
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
                textAlign: "center",
                backgroundImage:
                    "linear-gradient(135deg, #FBFCF8 0%, #F3F6EC 100%)",
            }}
        >
            <Stack
                spacing={1.5}
                alignItems="center"
            >
                {Icon && (
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#EEF0E6",
                        }}
                    >
                        <Icon
                            sx={{
                                fontSize: 28,
                                color: "#738B3B",
                            }}
                        />
                    </Box>
                )}

                <Typography
                    variant="h6"
                    fontWeight={700}
                >
                    {title}
                </Typography>

                {description && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            maxWidth: 420,
                        }}
                    >
                        {description}
                    </Typography>
                )}

                {tip && (
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="flex-start"
                        sx={{
                            mt: 1,
                            px: 2,
                            py: 1.25,
                            maxWidth: 460,
                            borderRadius: 2.5,
                            textAlign: "left",
                            backgroundColor: "#FFF6DA",
                            border: "1px solid",
                            borderColor: "#E8CE78",
                        }}
                    >
                        <TipsAndUpdatesIcon
                            sx={{
                                fontSize: 20,
                                mt: 0.15,
                                color: "#8A6D00",
                                flexShrink: 0,
                            }}
                        />

                        <Typography
                            variant="body2"
                            sx={{
                                color: "#6B5400",
                            }}
                        >
                            {tip}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Paper>
    );
};

export default AssessmentTabEmptyState;
